import { onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "../firebase/client";

export function useViewerAuth(): string | null {
	const [uid, setUid] = useState<string | null>(auth.currentUser?.uid ?? null);

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, (user) => {
			if (user) {
				setUid(user.uid);
			} else {
				signInAnonymously(auth).catch(console.error);
			}
		});

		return unsubscribe;
	}, []);

	return uid;
}
